import { Backdrop, Box, CircularProgress } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CreateScenario from "./Create/CreateScenario";
import EditScenario from "./Edit/EditScenario";
import Header from "./Header";
import {
	getAllEnum,
	getCustGrpRef,
	getScSTQ,
	getTrustLevel,
	getUserCountries,
} from "./scenarioSetupNewSlice";

import { getUserCountriesEdit } from "./Edit/editScenarioNewSlice";
import { useEffect } from "react";

export default function ScenarioSetupNew() {
	const dispatch = useDispatch();
	const setupState = useSelector((store) => store.scenarioSetupNew);

	const { editMode, isLoading } = setupState;

	const editStates = useSelector((store) => store.editScenarioNew);

	const { isLoadingEdit } = editStates;

	useEffect(() => {
		dispatch(getUserCountries());
		dispatch(getUserCountriesEdit());
		dispatch(getCustGrpRef());
		dispatch(getAllEnum());
		dispatch(getTrustLevel());
		dispatch(getScSTQ());
	}, [dispatch]);

	return (
		<Box>
			<Box>
				<Backdrop
					sx={{
						color: "#fff",
						zIndex: (theme) => theme.zIndex.drawer + 1,
					}}
					open={isLoadingEdit}
				>
					<CircularProgress />
				</Backdrop>
			</Box>

			<Box>
				<Backdrop
					sx={{
						color: "#fff",
						zIndex: (theme) => theme.zIndex.drawer + 1,
					}}
					open={isLoading}
				>
					<CircularProgress />
				</Backdrop>
			</Box>
			<Header />
			{editMode ? <EditScenario /> : null}
			{!editMode ? <CreateScenario /> : null}
		</Box>
	);
}
